import DaoBase from "./base";
import DaoChannel from "./channel";
import {$shutils} from "../../libs/snnh/snnh";

/**
 * 메인 추천 채널
 */
class DaoChannelRecommand extends DaoBase {
    title;
    /**
     *
     * @type {DaoChannel[]}
     */
    channels = [];

    constructor(json=null) {
        super(json);

        const channels = [];
        (this.items || []).forEach(channel => {
            channels.push(new DaoChannel(channel));
        });
        this.channels = channels;
        delete this.items;
    }

    /**
     * 채널인출
     * @returns {DaoChannel|null}
     */
    get channel() {
        if(this.channels.length) {
            const position = $shutils.random(0, this.channels.length - 1);
            const channel = this.channels.hasOwnProperty(position) ? this.channels[position] : this.channels[0];
            channel.headline = this.title;
            return channel;
        }
        return null;
    }
}

export default DaoChannelRecommand;


// WEBPACK FOOTER //
// ./src/modules/dao/channel.recommand.js